import { render, staticRenderFns } from "./Encuesta.vue?vue&type=template&id=4570136c&scoped=true&"
import script from "./Encuesta.vue?vue&type=script&lang=js&"
export * from "./Encuesta.vue?vue&type=script&lang=js&"
import style0 from "./Encuesta.vue?vue&type=style&index=0&id=4570136c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4570136c",
  null
  
)

export default component.exports